import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { IInfo } from './helixIcons';
import { useTranslation } from 'react-i18next';

export default function PasswordGuidelines() {
  const { t } = useTranslation();

  return (
    <Alert
      icon={<IInfo fontSize="inherit" style={{ color: '#191919' }} />}
      sx={{ background: '#effcfb', border: '1px solid #66e2da' }}
      severity="info"
    >
      <AlertTitle>{t('The password:')}</AlertTitle>
      <ul className={'password-policy-list'} style={{ paddingLeft: '1rem' }}>
        <li style={{ padding: '7px 3px' }}>
          {t('Must include the following:')}
          <ul style={{ paddingLeft: '1rem', marginLeft: '10px', marginTop: '4px' }}>
            <li style={{ padding: '3px' }}>{t('A lower case letter')}</li>
            <li style={{ padding: '3px' }}>{t('An upper case letter')}</li>
            <li style={{ padding: '3px' }}>{t('A number')}</li>
            <li style={{ padding: '3px' }}>
              {t('A special character e.g. #, $ etc')}
            </li>
          </ul>
        </li>
        <li>
          {t('Must be at least {{minCharLength}} characters long', {
            minCharLength: 10,
          })}
        </li>
        <li>{t("Can't contain your name")}</li>
        <li>{t("Can't contain your email address")}</li>
      </ul>
    </Alert>
  );
}
